import { Injectable } from '@angular/core';
import { forkJoin, map, Observable } from 'rxjs';
import { InvoiceRepository } from '../interfaces/invoice-repository.interface';

export interface InvoiceSummary {
  issued: number;
  errors: number;
}

@Injectable()
export class GetInvoiceSummaryUseCase {
  constructor(private readonly repository: InvoiceRepository) {}

  execute(): Observable<InvoiceSummary> {
    return forkJoin({
      issued: this.repository.getIssuedCount(),
      errors: this.repository.getErrorCount()
    }).pipe(map((summary) => summary));
  }
}

